var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.6,42.4C273.5,35.8,265,32,256,32c-9,0-17.5,3.8-23.6,10.4l-88,96c-11.9,13-11.1,33.3,2,45.2 c13.1,11.9,33.3,11.1,45.2-2l32.4-35.3V448c0,17.7,14.3,32,32,32c17.7,0,32-14.3,32-32V146.3l32.4,35.4c11.9,13,32.2,13.9,45.2,2 s13.9-32.2,2-45.2L279.6,42.4L279.6,42.4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SortArrowUp.8fbdf4709ebe8faee49073d39c0d2983.svg";